export const SITE_CONFIG = {
    name: 'es2be',
    description: 'Professional Digital Services & Premium Print Products',
    url: 'https://es2be.de',
    locale: 'DE',

    /* -------------------- Maintenance Mode -------------------- */
    /* Set to true to enable maintenance mode - shows maintenance page for all routes */
    maintenanceMode: false,

    contact: {
        email: 'mail[at]es2be.de',
        phone: '+49 30 12345678',
        address: 'Tech Street 123, 10115 Berlin, Germany',
    },

    social: {
        linkedin: 'https://www.linkedin.com/in/steven-balz-49778a3b5/',
        github: 'https://github.com/sbalz',
    },

    seo: {
        titleTemplate: '%s | es2be',
        defaultTitle: 'es2be | Digital & Print',
        defaultDescription:
            'Professional Digital Services & Premium Print Products',
        keywords: [
            'Zendesk',
            'Print Products',
            'Digital Services',
            'Calendars',
            'Web Development',
        ],
    },

    legal: {
        company: 'es2be',
        vat: '',
        commercialRegister: '',
        court: '',
    },
} as const;
